// Barre d'actions ANCRÉE en bas d'écran (fiches, scène, chat, quiz, tâche).
//
// À placer en FRÈRE du ScrollView, jamais dedans : à l'intérieur, elle défile avec le contenu
// et l'utilisateur doit descendre pour l'atteindre. Corollaire indispensable : toute la chaîne
// flex de l'écran — RACINE COMPRISE — doit porter `minHeight: 0`, sinon le conteneur grandit
// au lieu de laisser défiler et la barre repart sous la ligne de flottaison (cf. app/utils/cyb).
import { ReactNode, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { type Palette } from '../utils/cyb';
import { usePalette } from '../hooks/usePalette';

export default function ActionBar({ children }: { children: ReactNode }) {
  const C = usePalette();
  const s = useMemo(() => makeStyles(C), [C]);
  return (
    <View style={s.bar}>
      <View style={s.row}>{children}</View>
    </View>
  );
}

const makeStyles = (C: Palette) => StyleSheet.create({
  bar: {
    borderTopWidth: 1,
    borderTopColor: C.border,
    backgroundColor: C.surface,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  // Actions alignées à DROITE : c'est là que l'œil termine sa lecture, et c'est la convention
  // déjà retenue pour le bouton « Suivant » des fiches.
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 8 },
});
